import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../../appTheme";

export const modifierOptionsStyle = StyleSheet.create({
    container: {
        flex: 1
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    headerStyle: {
        color: appColors.primary,
        textAlign: 'left',
    },
    saveButtonStyle: {
        marginHorizontal: 15,
        right: 5,
        backgroundColor: appColors.primary,
        borderWidth: 1,
        borderColor: "transparent"
    },
    saveButtonTitleStyle: {
        color: appColors.light,
        fontSize: fontSize.smallerFontSize,
        fontFamily: appFonts.bold,
        marginHorizontal: 7
    },
    plusIconView: {
        alignSelf: "flex-end",
        backgroundColor: appColors.primary,
        borderRadius: 50,
        alignItems: "center",
        justifyContent: "center",
        height: 55,
        width: 55,
        position: "absolute",
        bottom: 25,
        right: 25
    },
    popoverStyle: {
        borderRadius: 10
    },
    badgeView: {
        padding: 7, alignItems: "center", borderRadius: 9, backgroundColor: '#ffedbd', paddingHorizontal: 10
    },
    badgeTextStyle: {
        fontFamily: appFonts.bold, fontSize: fontSize.badgeFontSize, color: appColors.lightDark
    },
    buttonViewStyle: {
        borderWidth: 0, marginHorizontal: 10, marginRight: 15, marginTop: 10
    },
    badgeContainerStyle: {
        position: "absolute", left: 15, top: -8, paddingHorizontal: 7
    },
    createBtnTextStyle: {
        fontSize: fontSize?.smallerFontSize, fontFamily: appFonts?.bold
    },
    buttonStyle: {
        borderRadius: 10, backgroundColor: appColors?.primary, marginTop: 10, paddingVertical: 2
    }
})